import { useDemand } from "lib/authorization/use-demand"
import {
    AUTHORING_ARCHIVE_WORK_PACKAGES_DEMAND,
    AUTHORING_VIEW_ARCHIVED_WORK_PACKAGES_DEMAND,
} from "authoring/lib/constants/authoring-permissions.mjs"
import { ArchivedWorkPackagesTile } from "./archived-work-packages-tile"

export function AuthoringHomeArchivedWorkPackages() {
    const canView = useDemand(
        [AUTHORING_VIEW_ARCHIVED_WORK_PACKAGES_DEMAND, AUTHORING_ARCHIVE_WORK_PACKAGES_DEMAND],
        false
    )

    if (!canView) return null

    return <ArchivedWorkPackagesTile />
}
